import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { StatementType } from '@app/modules/businesses/models/statements.models';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-mark-as-paid',
  templateUrl: './dialog-mark-as-paid.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogMarkAsPaidComponent {
  selectedDate: string = new Date().toDateString();
  public readonly isStatement = this.data.type === StatementType.Statement;

  constructor(
    public dialogRef: MatDialogRef<DialogMarkAsPaidComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { type: StatementType; ownerName: string; amountOwed: string }
  ) {}

  onDateSelected(date: string | string[]): void {
    if (typeof date === 'string') {
      this.selectedDate = date;
    } else if (Array.isArray(date) && date.length > 0) {
      this.selectedDate = date[0];
    }
  }

  closeDialog(): void {
    this.dialogRef.close(this.selectedDate);
  }
}
